export enum OnlineStatus {
  OFFLINE = 0,
  ONLINE = 1,
}
